import { INLINE_CREATE_VIEW_MODAL } from 'app/GlobalModalKeys'

import { useModalDeclaration } from 'v2/ui/utils/useModalToggle'

import { InlineCreateViewModalData } from './types'

export const useInlineCreateViewModal = (data: InlineCreateViewModalData) =>
    useModalDeclaration(INLINE_CREATE_VIEW_MODAL + data.objectId, undefined, data)
